import axios from 'axios';
import endpoints from '_apis';

/**
 * Define constants
 */
export const SET_IS_CAMPAIGN = 'SET_IS_CAMPAIGN';
export const TRIGGER_CAMPAIGN = 'TRIGGER_CAMPAIGN';
export const SET_CAMPAIGN_INFO = 'SET_CAMPAIGN_INFO';
export const SET_CAMPAIGN_PROMPT = 'SET_CAMPAIGN_PROMPT';
export const SET_HAS_ACTIVE_CAMPAIGN = 'SET_HAS_ACTIVE_CAMPAIGN';

/**
 * Action creators
 */
const actions = {
  triggerCampaign: (data) => ({ type: TRIGGER_CAMPAIGN, data }),
  setCampaignInfo: (data) => ({ type: SET_CAMPAIGN_INFO, data }),
  setHasActiveCampaign: (data) => ({ type: SET_HAS_ACTIVE_CAMPAIGN, data }),
  setIsCampaign: (data) => ({ type: SET_IS_CAMPAIGN, data }),
  setCampaignPrompt: (data) => ({ type: SET_CAMPAIGN_PROMPT, data })
};

export const getCampaignActiveStatus = (project, district) => async (dispatch) => {
  try {
    const { data } = await axios.get(endpoints.activeCampaignUrl(project, district));
    if (!data) throw new Error();
    dispatch(setHasActiveCampaign(true));
    dispatch(setCampaignInfo(data));
  } catch (E) {
    // There's no campaign
    dispatch(setHasActiveCampaign(false));
  }
};

export const setHasActiveCampaign = (active) => (dispatch) => {
  dispatch(actions.setHasActiveCampaign(active));
};

export const setCampaignInfo = (info) => (dispatch) => dispatch(actions.setCampaignInfo(info));

export const triggerCampaign = (state) => (dispatch) => dispatch(actions.triggerCampaign(state));

export const setCampaignPrompt = (data) => (dispatch) => dispatch(actions.setCampaignPrompt(data));

export const setIsCampaign = (isCampaign) => (dispatch) => dispatch(
  actions.setIsCampaign(isCampaign)
);
